import { render } from "./AtualizarECriarCa.vue?vue&type=template&id=1131b272&scoped=true"
import script from "./AtualizarECriarCa.vue?vue&type=script&lang=js"
export * from "./AtualizarECriarCa.vue?vue&type=script&lang=js"

import "./AtualizarECriarCa.vue?vue&type=style&index=0&id=1131b272&scoped=true&lang=css"
import "./AtualizarECriarCa.vue?vue&type=style&index=1&id=1131b272&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1131b272"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QImg,QBtn,QTd,QTooltip,QPagination,QDialog,QCard,QCardSection,QInput,QIcon,QPopupProxy,QDate,QSelect,QItem,QItemSection,QField});
